import React from 'react';
import { TextField } from '@mui/material';
import ValidatedTextField from 'common-mui/components/ValidatedTextField';
import { VEHICLE_MODEL_REGEX } from 'common-constants/validation';

const VehicleModel = ({
  control,
}) => (
  <ValidatedTextField
    name="vehicleModel"
    control={control}
    rules={{
      required: 'This field is required.',
      pattern: {
        value: VEHICLE_MODEL_REGEX,
        message: 'Model can only contain alphanumeric and certain special characters (-, +, /, \\, .).',
      },
    }}
  >
    <TextField fullWidth label="Model" />
  </ValidatedTextField>
);

export default VehicleModel;
